"use client";
import React, { memo } from "react";
import ImageWrapper from "../../ImageWrapper";
import { Text, Box } from "@dxp-feed/ui";
import { usePathname } from "next/navigation";
import Link from "@/components/Link";

const LoadedOffersToast = ({ mulesoftPendingOffers }: any) => {
  const pathname = usePathname();

  return (
    <>
      <Box as="div" className="flex p-0">
        <ImageWrapper
          src="/offers/Offer_cart.svg"
          alt="Sobeys"
          height={160}
          width={160}
          className="w-20 h-20 lgs:w-40 lgs:h-[100px]"
        />
        <Box as="div" className="flex flex-col items-start py-[4px]">
          <Text
            as="p"
            className="text-base lgs:text-xl font-sans text-brandBlack !font-light pb-[8px]"
          >
            <Text as="span" className="text-purple300 font-bold">
              {" "}
              {mulesoftPendingOffers?.length}{" "}
            </Text>{" "}
            <Text as="span" className="font-bold">
              {" "}
              digital offers{" "}
            </Text>{" "}
            <Text as="span" className="text-base lgs:!font-normal">
              have been successfully loaded to your Scene+ card – ready for you
              to use!
            </Text>
          </Text>
          {pathname !== "/offers" && (
            <Link
              href="/offers"
              className="block ml-[0px] font-bold text-brandBlack text-body underline hover:no-underline"
            >
              View All Loaded Offers
            </Link>
          )}
        </Box>
      </Box>
    </>
  );
};

export default memo(LoadedOffersToast);
